<template>
    <Head v-if="!loading" :title="__(appointment.title)" />
    <div class="task__details">
        <div class="wrapper" id="modal">
            <div role="alert" class="container">
                <div v-if="loading" class="content">
                    <div role="status" class="td__loader">
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div><div class="i__r" /></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div></div>
                        <div class="__f"><div><div class="i__1" /><div class="i__2" /></div></div>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div v-else>
                    <div class="content">

                        <div class="close_area">
                            <div class="wrap">
                                <span v-if="isPopup" @click="$emit('closeModal', true)" class="close__b">
                                    <icon class="h-6 w-6" name="close" />
                                </span>
                                <button v-else @click="$emit('closeModal', true)" class="close__b">
                                    <icon class="h-6 w-6" name="close" />
                                </button>
                            </div>
                        </div>
                        <div class="m__body">
                            <main class="main">
                                <!-- appointment details -->
                                <h1 style="font-size: 24px; font-weight: bold;">{{ isEditable ? 'Edit appointment' : 'Appointment Details' }}</h1>
                                <div style="margin-bottom: 10px;margin-top: 10px;">
                                    <div class="flex">
                                        <icon class="w-5 h-5 mr-3" name="edit" />
                                        <div class="flex-1">
                                            <span class="text-sm font-medium">{{__('Title')}}:</span>
                                        </div>
                                    </div>
                                    <p>
                                        <span v-if="isEditable">
                                            <input v-model="appointment.title" style="width: 300px;" />
                                        </span>
                                        <span v-else>
                                            {{ appointment.title }}
                                        </span>
                                    </p>
                                </div>
                                <div style="margin-bottom: 10px;">
                                    <div class="flex">
                                        <icon class="w-5 h-5 mr-3" name="details" />
                                        <div class="flex-1">
                                            <span class="text-sm font-medium">{{__('Information')}}:</span>
                                        </div>
                                    </div>
                                    <p>
                                        <span v-if="isEditable">
                                            <text-input v-model="appointment.information" style="width: 100%; height: 100%; max-width: 100%; max-height: 100%;" class="w-full"></text-input>
                                        </span>
                                        <span v-else>
                                            {{ appointment.information }}
                                        </span>
                                    </p>
                                </div>
                                <div style="margin-bottom: 10px;">
                                    <div class="flex">
                                        <icon class="w-5 h-5 mr-3" name="date" />
                                        <div class="flex-1">
                                            <span class="text-sm font-medium">{{__('Event Duration')}}:</span>
                                        </div>
                                    </div>
                                    <p>
                                        <span v-if="isEditable">
                                            {{__('Start Time')}} <input type="datetime-local" v-model="appointment.start_time" />
                                        </span>
                                        <span v-else>
                                            {{__('Start Time')}} {{ appointment.start_time }}
                                        </span>
                                    </p>
                                    <p>
                                        <span v-if="isEditable">
                                            {{__('End Time')}} <input type="datetime-local" v-model="appointment.finish_time" />
                                        </span>
                                        <span v-else>
                                            {{__('End Time')}} {{ appointment.finish_time }}
                                        </span>
                                    </p>
                                </div>
                                <div style="margin-bottom: 10px;">
                                    <div class="flex">
                                        <icon class="w-5 h-5 mr-3" name="board" />
                                        <div class="flex-1">
                                            <span class="text-sm font-medium">{{__('Specifications')}}:</span>
                                        </div>
                                    </div>
                                    <p>
                                        <span v-if="isEditable">
                                            {{__('Location')}}:
                                            <select-input v-model="appointment.location" class="w-full lg:w-1/3">
                                                <option value="1">Presencial</option>
                                                <option value="2">Virtual</option>
                                            </select-input>
                                        </span>
                                        <span v-else>
                                            {{__('Location')}}: {{ getLocation(appointment.location) }}
                                        </span>
                                    </p>
                                    <p>
                                        <span v-if="isEditable">
                                            {{__('Type')}}:
                                            <select-input v-model="appointment.type_id" class="w-full lg:w-1/3">
                                                <option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</option>
                                            </select-input>
                                        </span>
                                        <span v-else>
                                            {{__('Type')}}: {{ appointmentType }}
                                        </span>
                                    </p>
                                </div>
                                <div style="margin-bottom: 10px;">
                                    <div class="flex">
                                        <icon class="w-5 h-5 mr-3" name="users" />
                                        <div class="flex-1">
                                            <span class="text-sm font-medium">{{__('Collaborators')}}:</span>
                                        </div>
                                    </div>
                                    <span v-if="isEditable">
                                        <multiselect 
                                            v-model="selectedCollaborators" 
                                            :close-on-select="false"
                                            :options="users" 
                                            :searchable="true"
                                            mode="tags"
                                            placeholder="Select collaborators"
                                            class="custom-multiselect"></multiselect>
                                    </span>
                                    <span v-else>
                                        <multiselect 
                                            v-model="selectedCollaborators" 
                                            :close-on-select="false"
                                            :options="users" 
                                            :searchable="true"
                                            mode="tags"
                                            disabled="true"
                                            placeholder="Select collaborators"></multiselect>
                                    </span>
                                </div>
                                <div style="margin-bottom: 10px;"><span class="text-sm font-medium">{{__('Appointer')}}: {{ appointer }} </span> </div>
                                <div class="flex justify-between items-center action__buttons mt-2">
                                        <button v-if="isEditable" @click="deleteChanges()" type="button" class="text-red-600 hover:underline">{{ __('Delete') }}</button>
                                        <button type="button" class="small save" v-if="isEditable" @click="saveChanges()">{{ __('Save') }}</button>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Loader from '@/Shared/Loader'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import 'moment-duration-format';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import axios from 'axios';
import Multiselect from '@vueform/multiselect'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'

export default {
    props: {
        currentUserId: Number,
        id: {
            required: true,
        },
        types: {
            type: Array,
            default: () => []
        },
        users: {
            type: Array,
            default: () => []
        },
        isPopup: Boolean,
        view: { required: false },
    },
    emits: {closeModal: null},
    data() {
        return {
            showAssigneeBox: false,
            editDescription: false,
            showCommentBox: false,
            showLabelBox: false,
            showMoveCard: false,
            is_move: false,
            label_search: '',
            user_search: '',
            showEditLabelBox: false,
            loading: true,
            newCheckList: false,
            labels: null,
            existing_timer: null,
            list_items: null,
            projects: null,
            counter: { seconds: 0, timer: null, duration: 0 },
            activeTimerString: '',
            new_chek_list: {},
            move_object: {},
            new_comment: {},
            selectedCollaborators: [],
            label: {},
            task: {},
            appointer: '',
            appointmentType: '',
            
            colors: [
                {'name': 'subtle green', 'color': '#baf3db'}, {'name': 'subtle yellow', 'color': '#f8e6a0'}, {'name': 'subtle orange', 'color': '#ffe2bd'}, {'name': 'subtle red', 'color': '#ffd2cc'}, {'name': 'subtle purple', 'color': '#dfd8fd'},
                {'name': 'green', 'color': '#4bce97'}, {'name': 'yellow', 'color': '#e2b203'}, {'name': 'orange', 'color': '#faa53d'}, {'name': 'red', 'color': '#f87462'}, {'name': 'purple', 'color': '#9f8fef'},
                {'name': 'bold green', 'color': '#1f845a'}, {'name': 'bold yellow', 'color': '#946f00'}, {'name': 'bold orange', 'color': '#b65c02'}, {'name': 'bold red', 'color': '#ca3521'}, {'name': 'bold purple', 'color': '#6e5dc6'},
                {'name': 'subtle blue', 'color': '#cce0ff'}, {'name': 'subtle sky', 'color': '#c1f0f5'}, {'name': 'subtle lime', 'color': '#D3F1A7'}, {'name': 'subtle pink', 'color': '#fdd0ec'}, {'name': 'subtle black', 'color': '#dcdfe4'},
                {'name': 'blue', 'color': '#579dff'}, {'name': 'sky', 'color': '#60c6d2'}, {'name': 'lime', 'color': '#94c748'}, {'name': 'pink', 'color': '#e774bb'}, {'name': 'black', 'color': '#8590a2'},
                {'name': 'bold blue', 'color': '#0c66e4'}, {'name': 'bold sky', 'color': '#1d7f8c'}, {'name': 'bold lime', 'color': '#5b7f24'}, {'name': 'bold pink', 'color': '#ae4787'}, {'name': 'bold black', 'color': '#626f86'},
            ],
            editorOptions: {
                modules: {
                    toolbar: {
                        container: [
                            { 'header': [1, 2, 3, 4, 5, 6, false] },
                            'bold', 'italic', 'underline', { 'list': 'bullet' }, { 'list': 'ordered'},
                            'align', 'clean',
                            'blockquote', 'code-block',
                            // 'image'
                        ],
                        // handlers: { 'image': this.imageButtonClickHandler }
                    },
                    // imageDrop: true,
                }
            }
            
        }
    },
    components: {
        Icon, Loader, Link, Datepicker, QuillEditor, Head, Multiselect, SelectInput,TextInput
    },
    computed: {
        isEditable() {
            console.log(this.currentUserId);
            console.log(this.currentUserId === this.appointment.user_id);
            console.log(this.users);
            if(this.id == -1){
                return true;
            }
            return this.currentUserId === this.appointment.user_id;
        },
        isDeletable() {
            if(this.id != -1){
                return true;
            }
        }
    },
    methods: {
       
        sendNotification(uri, id, user_id){
            const data = {id}
            if(!!user_id){
                data.user_id = user_id;
            }
            axios.post(this.route(uri, data)).catch((error) => {
                console.log(error);
            })
        },
        getLocation(locationId) {
            switch (locationId) {
                case 1:
                    return "Presencial";
                case 2:
                    return "Virtual";
                default:
                    return "Unknown";
            }
        },

        getAppointmentType(id) {
            axios.post(`/json/appointment/type/${id}`)
            .then(response => {
                //console.log("Valor de appointment type:", response.data);
                this.appointmentType = response.data;
            })
            .catch(error => {
                console.error("Error al obtener el tipo de cita:", error);
                this.appointmentType = 'Unknown';
            });
        },
        
        saveChanges() {
            this.loading = true;
            const updatedAppointment = {
                title: this.appointment.title,
                information: this.appointment.information,
                start_time: this.appointment.start_time,
                finish_time: this.appointment.finish_time,
                location: this.appointment.location,
                type_id: this.appointment.type_id,
                selected_users: this.selectedCollaborators
            };

            axios.post(`/json/appointment/save/${this.id}`, updatedAppointment)
            .then(response => {
                console.log('Changes saved successfully:', response.data.updatedAppointments);

                this.loading = false;

                //this.sendNotification('send.mail.appointment', response.data.savedAppointment.id)
                this.$emit('changes-saved', response.data.updatedAppointments);
                this.$emit('closeModal', true);
            })
            .catch(error => {
                this.loading = false;
                console.error('Error saving changes:', error);
            });
        },

        deleteChanges() {

            this.loading = true;
            axios.post(`/json/appointment/delete/${this.id}`)
            .then(response => {
                console.log('appointment deleted successfully:', response.data);

                this.loading = false;
                this.$emit('appointment-deleted', response.data);
                this.$emit('closeModal', true)
            })
            .catch(error => {
                this.loading = false;
                console.error('Error deleting appointment:', error);
            });

            console.log("borrar")
        },

        async getAppointment(id){
            if (id === -1) {
                this.appointment = {
                    title: '',
                    information: '',
                    start_time: '',
                    finish_time: '',
                    location: 1, 
                    type_id: 1 
                };
                this.loading = false;
            }else{
                const appointmentResponse = await axios.get(this.route('json.appointment.get', id));
                if(Object.keys(appointmentResponse.data).length){
                    this.appointment = await appointmentResponse.data.appointment;
                    this.selectedCollaborators = await appointmentResponse.data.users_appointment;
                    this.appointer = await appointmentResponse.data.appointer;
                    await this.getOtherData();
                }else{
                    alert('something went wrong');
                }
            }
            
        },
        async getOtherData(){
            this.getAppointmentType(this.appointment.type_id);
            this.loading = false;
        },
    },
    created() {
        this.moment = moment
        this.getAppointment(this.id)
    },
    mounted() {
        let self = this;
        window.addEventListener('keyup', function(ev) {
            if(ev.key === "Escape"){
                if(self.isPopup){
                    self.$emit('closeModal', true)
                }
            }
        });
    },
    name: "appointment-details"
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style>
.custom-multiselect {
  --ms-tag-bg: #9CA3AF;
  --ms-tag-color: #FFFFFF;
  --ms-border-color: #262932;
  --ms-bg: #FFFFFF;
  --ms-option-color-selected-pointed: #262932;
  --ms-option-color-pointed: #262932;
    background-color: white;
    color: black; 
    --ms-placeholder-color: black; 
    --ms-placeholder-bg:white;
}

input.multiselect-tags-search{
    background-color: white !important;
}
</style>